export const LEILAO_QUERO_VER = "leilao_quero_ver";
export const LEILAO_HORARIO_BOM = "leilao_horario_bom";
export const LEILAO_PAGA_ATE = "leilao_paga_ate";

export const LEILAO_QUERO_PLACEHOLDER = "Ex: bolsa Chanel, relógio, cinto Gucci...";

export const LEILAO_HORARIO_OPTIONS = [
  "Manhã (9h–12h)",
  "Almoço (12h–14h)",
  "Tarde (14h–18h)",
  "Noite (18h–21h)",
  "Após 21h",
  "Fim de semana",
  "Qualquer horário",
];

export const LEILAO_BUDGET_OPTIONS = [
  "Até 1k",
  "Até 3k",
  "Até 5k",
  "Até 10k",
  "Até 15k",
  "Até 20k",
  "Até 30k",
  "Até 40k",
  "Até 50k",
  "Até 70k",
  "Até 90k",
  "Até 100k",
];

export const DEFAULT_LEILAO_FIELDS = [
  {
    name: LEILAO_QUERO_VER,
    label: "Fala pra gente — o que queres ver essa semana?",
    type: "text",
    required: true,
  },
  {
    name: LEILAO_HORARIO_BOM,
    label: "Qual horário é bom pra você participar do leilão?",
    type: "radio",
    options: LEILAO_HORARIO_OPTIONS,
    required: true,
  },
  {
    name: LEILAO_PAGA_ATE,
    label: "Pretende investir até quanto?",
    type: "radio",
    options: LEILAO_BUDGET_OPTIONS,
    required: true,
  },
];

export function normalizeLeilaoSurveyFields(fields) {
  const rows = (Array.isArray(fields) ? [...fields] : []).map((f) => ({ ...f }));
  return DEFAULT_LEILAO_FIELDS.map((def) => {
    const found = rows.find((f) => f.name === def.name);
    if (found) {
      return {
        ...found,
        ...def,
        options: def.options?.length ? def.options : found.options,
      };
    }
    return { ...def };
  });
}

export function displayFieldLabel(field) {
  const def = DEFAULT_LEILAO_FIELDS.find((f) => f.name === field?.name);
  return def?.label || field?.label || "";
}

export function fieldOptions(field) {
  const def = DEFAULT_LEILAO_FIELDS.find((f) => f.name === field?.name);
  return field?.options?.length ? field.options : def?.options || [];
}

export function isEmptyAnswer(field, value) {
  if (field?.type === "radio") return !value;
  return !String(value || "").trim();
}

export function isSurveyComplete(fields, answers) {
  if (!Array.isArray(fields)) return false;
  return fields.every((field) => {
    if (!field.required) return true;
    return !isEmptyAnswer(field, answers[field.name]);
  });
}
